export const createNavRouteSelector = route => state => {
  return state.nav[route];
};
export const navActiveRouteSelector = state => {
  return state.nav.active;
};